import {MyopMessages} from "../../common/MyopMessages";
import {ExecuteScriptMessage, ExecuteScriptReplyMessage} from "../../messages";
import {BaseWebComponentMessageHandler, MessageToHost} from "./BaseWebComponentMessageHandler.ts";
import {ShadowRootRef} from "../shadowRootRef.ts";
import {ExecuteScriptHandlerExecutor} from "../../common/messageHandlers/executeScriptHandler.ts";

export class ExecuteScriptHandler extends BaseWebComponentMessageHandler<ExecuteScriptMessage> {
    messageType = MyopMessages.ExecuteScriptMessage

    innerExecutor = (event: ExecuteScriptMessage, shadowRootRef: ShadowRootRef, messageToHost: MessageToHost) => {
        const replier = (data: any) => {
            messageToHost(new ExecuteScriptReplyMessage(event.handlerUniqueId, data));
        };

        ExecuteScriptHandlerExecutor(event, replier, shadowRootRef);
    }
}
